import React from 'react';
import cn from 'classnames';
import { bool, string, number, func, node, oneOfType, oneOf } from 'prop-types';
import { isNil } from '../../utils/utils';

const propTypes = {
  id: oneOfType([string, number]).isRequired,
  value: oneOfType([string, number]).isRequired,
  checked: bool.isRequired,
  onChange: func.isRequired,
  label: oneOfType([node]),
  type: oneOf(['checkbox', 'radio']),
  name: string,
  disabled: bool,
  inline: bool,
  className: string,
  children: node,
  isLabelNeed: bool,
};

const defaultProps = {
  type: 'checkbox',
  label: '',
  checked: false,
  inline: false,
  disabled: false,
  onChange() {},
};

const CustomControl = ({
  id,
  type,
  value,
  name,
  label,
  checked,
  disabled,
  onChange,
  className,
  inline,
  children,
}) => {
  const classes = cn('custom-control', `custom-${type}`, className, {
    'custom-control-inline': inline,
  });

  return (
    <div className={classes}>
      <input
        className="custom-control-input"
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        aria-checked={checked}
      />
      <label id={`label_for_${id}`} className="custom-control-label" htmlFor={id}>
        {isNil(children) ? label : children}
      </label>
    </div>
  );
};

CustomControl.propTypes = propTypes;
CustomControl.defaultProps = defaultProps;

export default CustomControl;
